import actionTypes from '../constants/action-types';

const pageUsedBlocks = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_PAGE_USED_BLOCKS: {
      const { pageId, usedBlocks } = action.payload;

      if (state.id !== pageId || !state.usedBlocks) return state;

      return {
        ...state,
        usedBlocks: [...new Set(usedBlocks)],
      };
    }

    default:
      return state;
  }
};

export default pageUsedBlocks;
